import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-sms-group-warning-dialog',
    template: `
    <h1 mat-dialog-title>You are about to send a message to multiple recipients.</h1>
    <div mat-dialog-content>
      <ul style="max-width: 450px;">
        <li><b>Group</b> - Replies are visible to everyone in the group (e.g., everyone can see everyone else's reply).</li>
        <li><b>Broadcast</b> - Messages are sent to every recipient individually. Replies are only visible to you.</li>
      </ul>
    </div>
    <div mat-dialog-actions style="justify-content: flex-end;">
      <button mat-button (click)="closeSendConfirmPopup('bulk')">Broadcast</button>
      <button mat-button (click)="closeSendConfirmPopup('group')">Group</button>
    </div>
  `,
    styles: [
        '.thread-list {height: 100%; padding: 0;}',
        '.thread-list:focus {border: none; outline: none}',
        '.thread-viewport {height: 100%}',
    ],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class GroupWarningDialogComponent {

  constructor(public dialogRef: MatDialogRef<GroupWarningDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  closeSendConfirmPopup(action: string) {
    this.dialogRef.close(action);
  }
}
